<template>
  <v-stepper
    alt-labels
    v-model="currentStep.stepNumber"
    class="elevation-0 stepper"
  >
    <v-stepper-header class="elevation-0">
      <template v-for="(step, index) in steps">
        <v-divider v-if="index > 0" :key="step.number"></v-divider>
        <v-stepper-step
          color="accent"
          edit-icon="$complete"
          :complete="step.stepNumber < currentStep.stepNumber"
          :step="step.stepNumber"
          :ripple="false"
          :key="step.stepNumber"
          @click="goToStep(step)"
        >
          {{ step.label }}
        </v-stepper-step>
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
  computed: {
    currentStep() {
      return this.steps.find((step) => step.routeName === this.$route.name);
    },
  },
  watch: {
    currentStep(val) {
      this.$emit("stepChanged", val);
    },
  },
  methods: {
    goToStep(step) {
      if (step.stepNumber < this.currentStep.stepNumber) {
        this.$router.push({ name: step.routeName });
      }
    },
  },
  mounted() {
    this.$emit("stepChanged", this.currentStep);
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-stepper {
  background: transparent;
}

.stepper {
  background: rgb(0, 255, 128);
}

:deep(.v-stepper__header) {
  max-width: 823px;
  margin: auto;
}

:deep(.v-stepper__step--complete) + hr {
  border: solid 4px $stepper-active !important;
  margin: 44px -74px 0 !important;
}

:deep(.v-stepper__step--active) + hr {
  border: solid 4px $stepper-inactive !important;
  margin: 44px -74px 0 !important;
}

:deep(.v-stepper__step--inactive) ~ hr {
  border: solid 4px $stepper-inactive !important;
  margin: 44px -74px 0 !important;
}

:deep(.v-stepper__step--inactive.v-stepper__step--complete) ~ hr {
  border: solid 4px $stepper-active !important;
}
</style>
